import { connect } from "react-redux";
import { HelpInstructionModel } from "../../models/common/IHelpInstructions";
import { UserRole } from "../../constants/RoleEnum";
import AdminHelpInstructions from "./components/adminHelpInstructions";
import StudentHelpInstructions from "./components/studentHelpInstructions";
import StaffHelpInstructions from "./components/staffHelpInstructions";
import FacultyHelpInstructions from "./components/facultyHelpInstructions";
import DepartmentAdminHelpInstructions from "./components/departmentAdminHelpInstructions";
import CollegeAdminHelpInstructions from "./components/collegeAdminHelpInstructions";
import FreshmanHelpInstructions from "./components/freshmanHelpInstructions";

const HelpInstructions = (props: HelpInstructionModel) => {
  const { currentUser } = props;

  const role = currentUser?.currentRole;

  if (role === UserRole.SuperAdmin) {
    return <AdminHelpInstructions />;
  }

  if (role === UserRole.DepartmentAdmin) {
    return <DepartmentAdminHelpInstructions />;
  }

  if (role === UserRole.CollegeAdmin) {
    return <CollegeAdminHelpInstructions />;
  }

  if (role === UserRole.Student) {
    if (currentUser?.isFreshman) {
      return <FreshmanHelpInstructions />;
    } else {
      return <StudentHelpInstructions />;
    }
  }

  if (role === UserRole.Staff) {
    return <StaffHelpInstructions />;
  }

  if (role === UserRole.Faculty) {
    return <FacultyHelpInstructions />;
  }

  return null;
};

function mapStateToProps(state: any) {
  return {
    currentUser: state.userDetails.userProfileData,
  };
}

export default connect(mapStateToProps, null)(HelpInstructions);
